import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {ISerializable} from 'cerialize';
import {EmailList} from '../../models/email-list';

export const EmailListTransformer: ISerializable = {
  Serialize(value: EmailList): string {
    return snakify(EmailList[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return EmailList[valueName];
    }
    return null;
  }
};
